import React from "react";

const PoliticasEnvio = () => {
  return (
    <div className="bg-gray-100 text-gray-800 py-10 px-5 sm:px-10 md:px-20 lg:px-40">
      <div className="bg-white border-2 border-GrisOscuro rounded-lg p-6">
        <h1 className="text-2xl md:text-3xl font-bold mb-6 text-center">Políticas de Envío</h1>

        {/* Sección 1: Alcance de los Envíos */}
        <h2 className="text-xl font-bold mt-6 mb-4">1. Alcance de los Envíos</h2>
        <p className="mb-4">
          En Agroh, nos comprometemos a garantizar que cada uno de nuestros productos llegue de manera segura y eficiente a nuestros clientes. Los servicios de envío están disponibles en: Argentina.
        </p>

        {/* Sección 2: Costos de Envío */}
        <h2 className="text-xl font-bold mt-6 mb-4">2. Costos de Envío</h2>
        <p className="mb-4">
          El costo asociado al envío de los productos será calculado en función de la ubicación del destinatario, el peso y las dimensiones de los artículos adquiridos, así como el método de envío seleccionado por el cliente. Agroh pondrá a disposición del cliente un desglose detallado de los gastos de envío en el momento de la compra.
        </p>

        {/* Sección 3: Tiempos de Entrega */}
        <h2 className="text-xl font-bold mt-6 mb-4">3. Tiempos de Entrega</h2>
        <p className="mb-4">
          Los plazos de entrega indicados son estimaciones basadas en las condiciones actuales de transporte y logística. Los tiempos aproximados de entrega son los siguientes:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>Envíos locales: 5 días.</li>
          <li>Envíos nacionales: 10 días.</li>
        </ul>

        {/* Sección 4: Dirección de Entrega */}
        <h2 className="text-xl font-bold mt-6 mb-4">4. Dirección de Entrega</h2>
        <p className="mb-4">
          Es responsabilidad exclusiva del cliente proporcionar una dirección de entrega correcta y completa. Agroh no se hará responsable por retrasos, reenvíos o pérdidas de productos derivadas de información incorrecta o incompleta proporcionada.
        </p>

        {/* Sección 5: Envíos Internacionales */}
        <h2 className="text-xl font-bold mt-6 mb-4">5. Envíos Internacionales</h2>
        <p className="mb-4">
          Para pedidos internacionales, el cliente será responsable de cubrir cualquier cargo adicional que pueda surgir durante el proceso de importación, tales como aranceles, impuestos o tarifas administrativas.
        </p>

        {/* Sección 6: Seguimiento de Envíos */}
        <h2 className="text-xl font-bold mt-6 mb-4">6. Seguimiento de Envíos</h2>
        <p className="mb-4">
          Una vez que el pedido haya sido procesado y enviado, el cliente recibirá un correo electrónico con un número de seguimiento que permitirá rastrear el estado de la entrega en tiempo real.
        </p>

        {/* Sección 7: Retrasos en la Entrega */}
        <h2 className="text-xl font-bold mt-6 mb-4">7. Retrasos en la Entrega</h2>
        <p className="mb-4">
          Si bien hacemos todo lo posible por cumplir con los plazos de entrega estimados, existen circunstancias imprevistas que pueden ocasionar retrasos.
        </p>

        {/* Sección 8: Problemas con la Entrega */}
        <h2 className="text-xl font-bold mt-6 mb-4">8. Problemas con la Entrega</h2>
        <p className="mb-4">
          Si el cliente no está disponible en el momento de la entrega, el transportista realizará un intento adicional de entrega o dejará una notificación con instrucciones.
        </p>

        {/* Sección 9: Productos Dañados o Perdidos Durante el Envío */}
        <h2 className="text-xl font-bold mt-6 mb-4">9. Productos Dañados o Perdidos Durante el Envío</h2>
        <p className="mb-4">
          Si un producto llega dañado o defectuoso, el cliente debe notificar a Agroh dentro de los 5 días posteriores a la recepción del paquete.
        </p>

        {/* Sección 10: Modificaciones a las Políticas de Envío */}
        <h2 className="text-xl font-bold mt-6 mb-4">10. Modificaciones a las Políticas de Envío</h2>
        <p className="mb-4">
          Agroh se reserva el derecho de modificar las presentes Políticas de Envío en cualquier momento, sin previo aviso.
        </p>
      </div>
    </div>
  );
};

export default PoliticasEnvio;
